import barba from "@barba/core";

const jumpArrowWrapper = document.querySelector(".jump-arrow-wrapper");
const jumpArrow = document.querySelector(".jump-arrow");
const footer = document.querySelector(".footer");
let shown = false;
let sections = [];

const initJumpArrow = () => {
	const updateSections = (container = document) => {
		sections = Array.from(
			container.querySelectorAll(
				'[data-jump-arrow-section]:not([data-jump-arrow-section="false"])'
			)
		);
	};

	const update = () => {
		if (document.body.classList.contains("single-post")) {
			if (window.scrollY + window.innerHeight > 2000) {
				jumpArrowWrapper.classList.add("jump-arrow-wrapper--footer");
				if (!shown) {
					shown = true;
					jQuery(jumpArrow).stop().fadeIn();
				}
			} else {
				if (shown) {
					shown = false;
					jQuery(jumpArrow).stop().fadeOut();
				}
			}
		} else {
			if (
				window.scrollY +
					window.innerHeight -
					jumpArrowWrapper.offsetHeight >
				footer.offsetTop
			) {
				jumpArrowWrapper.classList.add("jump-arrow-wrapper--footer");
				if (!shown) {
					shown = true;
					jQuery(jumpArrow).stop().fadeIn();
				}
			} else {
				if (
					sections.length > 0 &&
					window.scrollY - window.innerHeight / 2 <
						sections[sections.length - 1].offsetTop
				) {
					jumpArrowWrapper.classList.remove(
						"jump-arrow-wrapper--footer"
					);
					if (!shown) {
						shown = true;
						jQuery(jumpArrow).stop().fadeIn();
					}
				} else {
					if (shown) {
						shown = false;
						jQuery(jumpArrow).stop().fadeOut();
					}
				}
			}
		}
	};

	const jump = () => {
		if (
			window.scrollY +
				window.innerHeight -
				jumpArrowWrapper.offsetHeight >
				footer.offsetTop ||
			document.body.classList.contains("single-post")
		) {
			jQuery("html, body").animate(
				{
					scrollTop: 0,
				},
				1000
			);
		} else {
			if (
				sections.length > 0 &&
				window.scrollY - window.innerHeight / 2 <
					sections[sections.length - 1].offsetTop
			) {
				const section = sections.find(
					(section) =>
						window.scrollY - window.innerHeight / 2 <
						section.offsetTop
				);
				if (section) {
					let offset = 0;
					if (section.dataset.jumpArrowSection === "with-space") {
						offset =
							window.innerWidth >= 640
								? window.innerWidth >= 1200
									? 168
									: 192
								: 96;
					}
					jQuery("html, body").animate(
						{
							scrollTop:
								section.offsetTop +
								section.offsetHeight +
								offset,
						},
						500
					);
				}
			}
		}
	};

	document.addEventListener("scroll", update, { passive: true });
	jumpArrow.addEventListener("click", jump);
	updateSections();
	update();

	barba.hooks.beforeEnter((data) => {
		updateSections(data.next.container);
		update();
	});
};
document.addEventListener("DOMContentLoaded", initJumpArrow);
